import { useEffect } from "react";
import { shortcutManager } from "./shortcutManager";

export function useShortcutAction(actionId, handler, options) {
  useEffect(() => {
    if (!actionId || typeof handler !== "function") return undefined;
    return shortcutManager.registerAction(actionId, handler, options);
  }, [actionId, handler, options]);
}
